import ApiBase from './api_base'
import lodash from 'lodash'

export default class CategoryApi {
  static index(params) {
    return ApiBase.get('/categories', lodash.pick(params, ['organization_id']))
  }

  static show(id) {
    return ApiBase.get(`/categories/${id}`)
  }

  static destroy(id) {
    return ApiBase.delete(`/categories/${id}`)
  }

  static createOrUpdate(params) {
    let create = params => {
      return ApiBase.post(params.organization_id ? `/organizations/${params.organization_id}/categories` : '/categories', {
        category: lodash.pick(params, ['name', 'description', 'cover', 'publicity', 'order'])
      })
    }

    let update = params => {
      return ApiBase.put(`/categories/${params.id}`, {
        category: lodash.pick(params, ['name', 'description', 'cover', 'publicity', 'order'])
      })
    }
    return params.id ? update(params) : create(params)
  }
}



// WEBPACK FOOTER //
// ./src/api/category.js